/**
 * VideosTabContent
 * Videos tab showing AI-generated and user-created video guides
 */

import type { IssueDetails } from '../../../../domain'
import { VideoGallery } from '../panels'
import { FeedbackLink, TabContentLayout } from '../shared'

export interface VideosTabContentProps {
  issue: IssueDetails
}

export function VideosTabContent({ issue }: VideosTabContentProps) {
  const videos = issue.videos || []

  return (
    <TabContentLayout>
      <VideoGallery videos={videos} title="Video Guides" />
      <FeedbackLink context="videos" />
    </TabContentLayout>
  )
}
